import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import ContactCTA from '../components/ContactCTA';
import FAQ from '../components/FAQ';

// Import all product images
import KioskOrder from '../assets/images/machine-order.png';
import HardwareDevice from '../assets/images/Hardware-Device.png';
import SoftwareDevice from '../assets/images/softWareHeroSection.png';
import VernPOSHand from '../assets/images/vernposhand.png';
/*import Restaurant from '../assets/images/restaurant.png';
import Retail from '../assets/images/retail.png';
import Cafe from '../assets/images/cafe.png';
import MobileTaking from '../assets/images/mobiletaking.png';*/

// Import hardware product images
import LandIMG from '../assets/images/iMin D4 Pro.png';
import iMinIMG from '../assets/images/iMin D4 Pro1.png';
import wizarQ2IMG from '../assets/images/WizarPOS Q2.png';
import wizarQ8IMG from '../assets/images/WizarPOS Q8.png';

// Import business type images
import B1Img from '../assets/images/b1.png';
import B2Img from '../assets/images/b2.png';
import B3Img from '../assets/images/b3.png';
import B4Img from '../assets/images/b4.png';
import B5Img from '../assets/images/b5.png';
import B6Img from '../assets/images/b6.png';

// Import icons
import wifiIcon from '../assets/svg/wifi.svg';
import chipIcon from '../assets/svg/chip.svg';
import screenIcon from '../assets/svg/screen.svg';
import android from '../assets/svg/android.svg';
/*import cloudIcon from '../assets/svg/cloud.svg';
import multiIcon from '../assets/svg/multi-dev.svg';
import uiIcon from '../assets/svg/ui.svg';
import spanaIcon from '../assets/svg/spana.svg';*/
import { CreditCard, BarChart2, Gift, Coins, Monitor, Smartphone, /*Tablet, */Zap, Shield, Users, TrendingUp } from 'lucide-react';

const Products = () => {
  const navigate = useNavigate();

  const hardwareModels = [
    {
      name: "Landi C20 Pro",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi + 4G (SIM)", subtitle: "Network Connection" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "8GB + 128GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "15.6\" 1920 x 1080", subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" }
      ],
      image: LandIMG,
      description: "High-performance POS terminal for busy environments"
    },
    {
      name: "iMin D4 Pro",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi 6", subtitle: "Network Connection" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "15.6\" 1920 x 1080", subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" }
      ],
      image: iMinIMG,
      description: "Reliable and efficient POS solution for medium businesses"
    },
    {
      name: "WizarPOS Q2",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi + 4G (SIM)", subtitle: "Network Connection" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "2GB + 32GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "5.5\" 720 x 1280", subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 14", subtitle: "Operating System" }
      ],
      image: wizarQ2IMG,
      description: "Compact mobile POS for on-the-go transactions"
    },
    {
      name: "WizarPOS Q8",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi + 4G (SIM)", subtitle: "Network Connection" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "2GB + 16GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: "8\" 800 x 1280", subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 10", subtitle: "Operating System" }
      ],
      image: wizarQ8IMG,
      description: "Versatile tablet POS for flexible business setups"
    }
  ];

  const businessTypes = [
    {
      id: 1,
      image: B1Img,
      alt: "Busy café with customers and staff",
      title: "F&B / Café",
      description: "Streamline food service operations with menu management and order tracking"
    },
    {
      id: 2,
      image: B2Img,
      alt: "Service-based business professional",
      title: "Service Center",
      description: "Manage appointments, services, and customer relationships efficiently"
    },
    {
      id: 3,
      image: B3Img,
      alt: "Modern retail clothing store",
      title: "Retail Outlet",
      description: "Handle inventory, sales, and customer loyalty programs seamlessly"
    },
    {
      id: 4,
      image: B4Img,
      alt: "Auto service workshop",
      title: "Workshop",
      description: "Track repairs, parts inventory, and customer service history"
    },
    {
      id: 5,
      image: B5Img,
      alt: "Grocery store with products",
      title: "Grocery",
      description: "Manage perishable inventory and bulk sales with ease"
    },
    {
      id: 6,
      image: B6Img,
      alt: "Restaurant kitchen with chef",
      title: "Restaurant",
      description: "Full-service restaurant management from kitchen to table"
    }
  ];

  const softwareFeatures = [
    {
      icon: <Monitor size={32} className="text-vern" />,
      title: "Real-Time Dashboard",
      description: "Monitor sales, inventory, and performance from anywhere"
    },
    {
      icon: <BarChart2 size={32} className="text-vern" />,
      title: "Advanced Analytics",
      description: "Get insights into sales trends and customer behavior"
    },
    {
      icon: <CreditCard size={32} className="text-vern" />,
      title: "Multi-Payment Support",
      description: "Accept cards, mobile wallets, and QR payments"
    },
    {
      icon: <Users size={32} className="text-vern" />,
      title: "Staff Management",
      description: "Manage roles, permissions, and performance tracking"
    },
    {
      icon: <Shield size={32} className="text-vern" />,
      title: "Secure Cloud Storage",
      description: "Your data is safe with enterprise-grade security"
    },
    {
      icon: <TrendingUp size={32} className="text-vern" />,
      title: "Scalable Solution",
      description: "Grow your business with our flexible platform"
    }
  ];

  const kioskFeatures = [
    {
      icon: <Smartphone size={32} className="text-vern" />,
      title: "Self-Service Ordering",
      description: "Let customers order directly, reducing wait times"
    },
    {
      icon: <Coins size={32} className="text-vern" />,
      title: "Upselling Features",
      description: "Suggest add-ons to boost average order value"
    },
    {
      icon: <CreditCard size={32} className="text-vern" />,
      title: "Integrated Payments",
      description: "Accept cards & mobile wallets seamlessly"
    },
    {
      icon: <Gift size={32} className="text-vern" />,
      title: "Loyalty Programs",
      description: "Engage customers with rewards and discounts"
    },
    {
      icon: <BarChart2 size={32} className="text-vern" />,
      title: "Analytics & Reporting",
      description: "Get sales and customer insights in real-time"
    },
    {
      icon: <Zap size={32} className="text-vern" />,
      title: "Fast Setup",
      description: "Quick installation and easy customization"
    }
  ];

  const faqs = [
    {
      question: "What types of businesses can benefit from VernPOS solutions?",
      answer: "VernPOS is designed for a wide range of businesses including restaurants, cafes, retail stores, service centers, workshops, and grocery stores. Our solutions are customizable to fit your specific industry needs and business size."
    },
    {
      question: "Can I use VernPOS on multiple devices?",
      answer: "Yes! VernPOS is a cloud-based system that works across multiple devices. You can access your POS from tablets, smartphones, computers, and dedicated POS terminals, all synchronized in real-time."
    },
    {
      question: "How does the kiosk system integrate with my existing POS?",
      answer: "Our kiosk system integrates seamlessly with VernPOS software. Orders placed through kiosks automatically sync with your main POS system, ensuring accurate inventory tracking and order management."
    },
    {
      question: "What payment methods does VernPOS support?",
      answer: "VernPOS supports multiple payment methods including credit/debit cards, mobile wallets (Apple Pay, Google Pay), QR code payments, and cash transactions. We're constantly adding new payment options."
    },
    {
      question: "Is my data secure with VernPOS?",
      answer: "Absolutely. We use enterprise-grade security with encrypted data transmission and secure cloud storage. Your business data is protected with multiple layers of security measures."
    },
    {
      question: "Do you provide training and support?",
      answer: "Yes, we provide comprehensive training for your staff, ongoing technical support, and regular software updates. Our team is always available to help you get the most out of VernPOS."
    }
  ];

  return (
    <div className="min-h-screen bg-white scroll-smooth">
      <SEO
        title="Complete POS Solutions | Hardware, Software & Kiosks | VernPOS Malaysia"
        description="Discover VernPOS complete ecosystem: POS hardware, cloud software, and self-service kiosks. Perfect for F&B, retail, and service businesses across Malaysia."
        keywords="POS system Malaysia, POS hardware, cloud POS software, self-service kiosk, restaurant POS, retail POS, F&B solutions, VernPOS ecosystem"
      />

      {/* Hero Section */}
      <section className="relative min-h-screen overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 right-0 h-[70%] bg-gradient-to-br from-vern to-red-700"></div>
          <div className="absolute bottom-0 left-0 right-0 h-[30%] bg-white"></div>
          <div className="absolute left-0 right-0" style={{ top: '100%', height: '10%' }}>
            <svg viewBox="0 0 1200 120" className="w-full h-full" preserveAspectRatio="none">
              <path d="M0,0 C400,80 800,80 1200,0 L1200,120 L0,120 Z" fill="white" />
            </svg>
          </div>
        </div>

        <div className="relative z-10 container mx-auto max-w-6xl px-4 pt-32 pb-16">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight max-w-5xl mx-auto">
              Complete POS Ecosystem for Modern Businesses
            </h1>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed max-w-4xl mx-auto mb-8">
              From powerful hardware to intelligent software and self-service kiosks — everything you need to run your business efficiently, all in one place.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => navigate('/contact-us')}
                className="bg-white text-vern hover:bg-gray-100 font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105"
              >
                Get Started Today
              </button>
              <button 
                onClick={() => navigate('/contact-us')}
                className="border-2 border-white text-white hover:bg-white hover:text-vern font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105"
              >
                Schedule Demo
              </button>
            </div>
          </div>

          {/* Product Showcase Grid - Redesigned with Anchor Links */}
          <div className="max-w-6xl mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* POS Hardware Card */}
              <a href="#hardware" className="focus:outline-none">
                <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center transition-transform duration-200 hover:-translate-y-2 hover:shadow-2xl border border-transparent hover:border-vern cursor-pointer">
                  <img src={HardwareDevice} alt="POS Hardware" className="w-24 h-24 mb-4 object-contain" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">POS Hardware</h3>
                  <p className="text-gray-600 text-base">Professional devices built for reliability</p>
                </div>
              </a>
              {/* Cloud Software Card */}
              <a href="#software" className="focus:outline-none">
                <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center transition-transform duration-200 hover:-translate-y-2 hover:shadow-2xl border border-transparent hover:border-vern cursor-pointer">
                  <img src={SoftwareDevice} alt="Cloud Software" className="w-24 h-24 mb-4 object-contain" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Cloud Software</h3>
                  <p className="text-gray-600 text-base">Intelligent platform for business growth</p>
                </div>
              </a>
              {/* Self-Service Kiosks Card */}
              <a href="#kiosk" className="focus:outline-none">
                <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center transition-transform duration-200 hover:-translate-y-2 hover:shadow-2xl border border-transparent hover:border-vern cursor-pointer">
                  <img src={KioskOrder} alt="Self-Service Kiosks" className="w-24 h-24 mb-4 object-contain" />
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Self-Service Kiosks</h3>
                  <p className="text-gray-600 text-base">Enhance customer experience</p>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-1/4 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl"></div>
        <div className="absolute top-1/3 right-16 w-32 h-32 bg-red-400/20 rounded-full blur-2xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-24 h-24 bg-white/5 rounded-full blur-lg"></div>
      </section>

      {/* Hardware Solutions Section */}
      <section id="hardware" className="pt-0 py-20 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Professional POS Hardware
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Choose from our range of high-performance POS terminals designed for reliability and efficiency. All devices are fully compatible with VernPOS software.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {hardwareModels.map((model, index) => (
              <div key={index} className="bg-gray-50 border border-gray-200 rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <div className="flex flex-col lg:flex-row items-center gap-8">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-vern mb-3">{model.name}</h3>
                    <p className="text-gray-600 mb-6">{model.description}</p>
                    
                    <div className="space-y-4">
                      {model.specs.map((spec, specIndex) => (
                        <div key={specIndex} className="flex items-center gap-3">
                          <span className="text-2xl">{spec.icon}</span>
                          <div>
                            <div className="font-semibold text-gray-800">{spec.text}</div>
                            <div className="text-sm text-gray-600">{spec.subtitle}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex-1 text-center">
                    <img 
                      src={model.image}
                      alt={model.name}
                      className="max-w-full h-auto max-h-64 object-contain mx-auto"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button 
              onClick={() => navigate('/hardware')}
              className="bg-vern hover:bg-red-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105"
            >
              Explore All Hardware
            </button>
          </div>
        </div>
      </section>

      {/* Software Solutions Section */}
      <section id="software" className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
                Intelligent Cloud POS Software
              </h2>
              <p className="text-lg text-gray-700 mb-8">
                Powerful, cloud-based POS software that grows with your business. Manage sales, inventory, staff, and customers from anywhere with real-time synchronization.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {softwareFeatures.slice(0, 4).map((feature, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="bg-vern/10 rounded-full p-3 flex-shrink-0">
                      {feature.icon}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">{feature.title}</h3>
                      <p className="text-sm text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={() => navigate('/software')}
                  className="bg-vern hover:bg-red-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300"
                >
                  Learn More
                </button>
                <a
                  href="https://play.google.com/store/apps/details?id=com.vernpos.posnative"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                >
                  <img
                    src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
                    alt="Get Vern POS on Google Play"
                    className="h-16 w-auto"
                  />
                </a>
              </div>
            </div>

            <div className="text-center">
              <img 
                src={SoftwareDevice} 
                alt="VernPOS Software Interface" 
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Kiosk Solutions Section */}
      <section id="kiosk" className="py-20 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
            <div className="text-center lg:text-left">
              <img 
                src={KioskOrder} 
                alt="Self-Service Kiosk" 
                className="max-w-full h-auto object-contain mb-8 lg:mb-0"
              />
            </div>

            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
                Self-Service Kiosk Solutions
              </h2>
              <p className="text-lg text-gray-700 mb-8">
                Transform your customer experience with our intelligent self-service kiosks. Reduce wait times, increase order accuracy, and boost revenue with automated ordering.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {kioskFeatures.slice(0, 4).map((feature, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="bg-vern/10 rounded-full p-3 flex-shrink-0">
                      {feature.icon}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">{feature.title}</h3>
                      <p className="text-sm text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8">
                <button 
                  onClick={() => navigate('/contact-us')}
                  className="bg-vern hover:bg-red-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300"
                >
                  Get Kiosk Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Solutions Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Built for Every Business Type
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Whether you're running a restaurant, retail store, or service center, VernPOS adapts to your unique workflow and industry requirements.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {businessTypes.map((business) => (
              <div 
                key={business.id} 
                className="bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={business.image}
                    alt={business.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{business.title}</h3>
                  <p className="text-gray-600">{business.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Integration & Ecosystem Section */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Seamless Integration Ecosystem
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              All VernPOS products work together seamlessly, creating a unified business management solution that grows with you.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center p-8 bg-gradient-to-br from-vern/5 to-red-100 rounded-3xl">
              <div className="w-20 h-20 bg-vern/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <img src={HardwareDevice} alt="Hardware" className="w-12 h-12 object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Hardware</h3>
              <p className="text-gray-600">Professional POS terminals with built-in payment processing and connectivity</p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-vern/5 to-red-100 rounded-3xl">
              <div className="w-20 h-20 bg-vern/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <img src={SoftwareDevice} alt="Software" className="w-12 h-12 object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Software</h3>
              <p className="text-gray-600">Cloud-based management platform with real-time analytics and reporting</p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-vern/5 to-red-100 rounded-3xl">
              <div className="w-20 h-20 bg-vern/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <img src={KioskOrder} alt="Kiosk" className="w-12 h-12 object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Kiosks</h3>
              <p className="text-gray-600">Self-service ordering solutions that enhance customer experience</p>
            </div>
          </div>

          <div className="text-center">
            <img src={VernPOSHand} alt="VernPOS Ecosystem" className="max-w-2xl mx-auto mb-8" />
            <p className="text-lg text-gray-700 mb-8">
              Everything connected, everything synchronized, everything optimized for your success.
            </p>
            <button 
              onClick={() => navigate('/contact-us')}
              className="bg-vern hover:bg-red-700 text-white font-semibold py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-105 text-lg"
            >
              Start Your Journey Today
            </button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto max-w-4xl">
          <FAQ title="Frequently Asked Questions" faqs={faqs} />
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <ContactCTA />
        </div>
      </section>
    </div>
  );
};

export default Products;